import { FC } from 'react';
import { NormalizedArticleHit } from '../../../../../shared/types';

type HitProps = {
  hit: NormalizedArticleHit;
};

export const Hit: FC<HitProps> = ({ hit }) => {
  const { image, description, title, handle } = hit;

  return (
    <div className="ais-article-item">
      {image ? (
        <div className="ais-article-image">
          <a href={`/pages/${handle}`}>
            <img src={image} alt={title} />
          </a>
        </div>
      ) : null}

      <div className="ais-article-content">
        <h2>
          <a href={`/pages/${handle}`}>{title}</a>
        </h2>
        {description && description.length > 0 && <p>{description}</p>}
      </div>
    </div>
  );
};
